"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ssrWindow = require("ssr-window");

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var ModalContent =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ModalContent, _Component);

  function ModalContent(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ModalContent);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ModalContent).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onWindowResize", function (evt) {
      var _this$props = _this.props,
          maxHeight = _this$props.maxHeight,
          contentAreaHeight = _this$props.contentAreaHeight,
          verticalModalPadding = _this$props.verticalModalPadding;
      var windowWidth = _ssrWindow.window.innerWidth || _ssrWindow.document.body.clientWidth;
      var calculatedMax = maxHeight;

      if ((0, _isString.default)(calculatedMax) && calculatedMax === 'auto') {
        var modalWrapperEl = _dom.default.parent(_this._container, '.Modal-wrapper');

        var titleEl = modalWrapperEl.querySelector('.Modal-title');
        var finalContentAreaHeight = (0, _isUndefined.default)(contentAreaHeight) ? _dom.default.height(modalWrapperEl, true, false) - _dom.default.height(titleEl) : (0, _isFunction.default)(contentAreaHeight) ? contentAreaHeight() : contentAreaHeight;
        calculatedMax = windowWidth < 768 ? finalContentAreaHeight : finalContentAreaHeight - verticalModalPadding - 24; // 24 is margin-bottom
      }

      _this._container.style.maxHeight = "".concat(calculatedMax, "px");
    });
    var children = props.children,
        html = props.html;

    if (children && html) {
      throw new Error('Passing children or html props is exclusive. You may only use one at a time.');
    }

    return _this;
  }

  (0, _createClass2.default)(ModalContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _ssrWindow.window.addEventListener('resize', this._onWindowResize);

      this._onWindowResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _ssrWindow.window.removeEventListener('resize', this._onWindowResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          noPadding = _this$props2.noPadding,
          contentAreaHeight = _this$props2.contentAreaHeight,
          children = _this$props2.children,
          html = _this$props2.html;
      var content = html ? _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: html
        }
      }) : children;
      var classes = (0, _classnames.default)('Modal-content', {
        'Modal-content-flush': noPadding
      }, {
        'Modal-content-with-height': !(0, _isUndefined.default)(contentAreaHeight)
      }, className);
      return _react.default.createElement("div", {
        ref: function ref(node) {
          _this2._container = node;
        },
        className: classes
      }, _react.default.createElement("div", {
        className: "Modal-content-wrapper"
      }, content));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return ModalContent;
}(_react.Component);

exports.default = ModalContent;
(0, _defineProperty2.default)(ModalContent, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The elements to display as children. */
  children: _propTypes.default.node,

  /** Removes the padding of the content and makes it flush with the edges. */
  noPadding: _propTypes.default.bool,

  /** Sets a maximum height on the content. */
  maxHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),

  /** Sets content area height. */
  contentAreaHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),

  /** HTML markup to set as the content. Useful for rendering server side HTML responses inside of the component. */
  html: _propTypes.default.string,

  /** On all but the smallest breakpoints, the padding to add around the containing modal wrapper if the content height were to exceed 100% window height, effectively showing more of the shim. */
  verticalModalPadding: _propTypes.default.number
});
(0, _defineProperty2.default)(ModalContent, "defaultProps", {
  maxHeight: 'auto',
  verticalModalPadding: 32
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ModalContent, "ModalContent", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Modal/ModalContent.jsx");
  leaveModule(module);
})();

;